import React from 'react';

import { Box, Link, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const NameFormatter = ({ row }) => {
    const { t } = useTranslation();
    return (
        <Box display="flex" flexDirection="column">
            <Link
                href={`/templates/edition/${row.id}`}
                underline="hover"
                sx={{ textAlign: 'left', color: '#424242' }}
            >
                <Typography fontWeight="bold" variant="caption">
                    {row.title}
                </Typography>
            </Link>
            <Typography variant="caption">
                {row.pages} {t('Sheet', { count: row.pages.length })}
            </Typography>
        </Box>
    );
};

NameFormatter.propTypes = {
    row: PropTypes.object,
};

export default NameFormatter;
